// features/knowledge-base.validation.js

export const knowledgeBaseValidation = {
  title: (value) => {
    if (!value?.trim()) return "Title is required";
    return "";
  },
  order: (value) => {
    if (value === "" || value === null || value === undefined) return "";
    const num = Number(value);
    if (!Number.isInteger(num) || num < 0) return "Order must be a non-negative whole number";
    return "";
  },
  user_role_fids: (value) => {
    if (!Array.isArray(value) || value.length === 0) {
      return "Select at least one role";
    }
    return "";
  },
  // With the Client role, at least one Trade of Work or Business Type must be
  // chosen; picking both narrows the chapter to clients matching both.
  trade_of_work_fids: (value, formData) => {
    const hasTrade = Array.isArray(value) && value.length > 0;
    const hasBusinessType = Array.isArray(formData?.business_type_fids) && formData.business_type_fids.length > 0;
    if (!hasTrade && !hasBusinessType) {
      return "Select at least one trade of work or business type";
    }
    return "";
  },
  business_type_fids: () => "",
};
